import InputIconSearchPanelMultiSelection from "./InputIconSearchPanelMultiSelection";
import InputSearch from "./InputSearch";
import Tag from "./Tag";
import DataTable from "react-data-table-component";
import ButtonIconH from "./ButtonIconH";
import DropdownFilter from "./DropdownFilter";
import { useEffect, useState } from "react";
import {
  userData,
  inputOnEnter,
  crmChannels,
  formatValueUnit,
} from "../js/utils";
import { post } from "../js/post";
import moment from "moment";
import { CRMHistoryColumns } from "../js/tableColumns";

export function HistoryCRM() {
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [campaignsList, setCampaignsList] = useState([]);
  const [selectedCampaignsList, setSelectedCampaignsList] = useState([]);
  const [filterCodPaciente, setFilterCodPaciente] = useState("");
  const [searchData, setSearchData] = useState({
    campana: [],
    idPaciente: -1,
    fechaDesde: "",
    fechaHasta: "",
    canal: selectedChannels,
    start: 0,
    total: 25,
  });
  const [data, setData] = useState({ total: "", historico: [] });
  const [historyList, setHistoryList] = useState([]);

  // console.log("SEARCH DATA: ", searchData);
  // console.log("HISTORIAL CRM: ", data);
  // console.log("HISTORIAL CRM FIX: ", historyList);

  async function getCampaignsList() {
    const response = await post("support-extra/crm/ListarCampanasCRM.php", {
      token: userData.token,
      nombre: "",
      fechaDesde: "",
      fechaHasta: "",
      canal: selectedChannels,
      start: 0,
    });
    setCampaignsList(response.campanas);
  }

  async function getCRMHistory() {
    const response = await post("support-extra/crm/ListarHistorialCRM.php", {
      token: userData.token,
      ...searchData,
    });
    // console.log(
      // "LISTAR HISTORIAL CRM: ",
      // {
        // token: userData.token,
        // ...searchData,
      // },
      // response,
    // );
    setData(response);
    if (searchData.start === 0) {
      setHistoryList(response.historico);
    } else {
      setHistoryList((prev) => [...prev, ...response.historico]);
    }
  }

  const resetFilters = () => {
    setSelectedChannels([]);
    setSelectedCampaignsList([]);
    setFilterCodPaciente("");
    setSearchData({
      campana: [],
      idPaciente: -1,
      fechaDesde: "",
      fechaHasta: "",
      canal: [],
      start: 0,
      total: 25,
    });
  };

  const onSelectPatient = (e) => {
    setFilterCodPaciente(e.codigo);
    setSearchData((prev) => ({
      ...prev,
      idPaciente: e.idPaciente,
      start: 0,
    }));
  };

  const onChangePatient = (e) => {
    if (e === "") {
      setFilterCodPaciente("");
      setSearchData((prev) => ({
        ...prev,
        idPaciente: -1,
        start: 0,
      }));
    }
  };

  const onLinkPatient = () => {
    if (filterCodPaciente !== "") {
      window.open(`/patient-datos/${searchData.idPaciente}`);
    }
  };

  useEffect(() => {
    const channelMap = { WHATSAPP: "Whatsapp", EMAIL: "Email" };
    const mappedChannels = selectedChannels.map((c) => channelMap[c] || c);
    setSearchData((prev) => ({
      ...prev,
      canal: mappedChannels,
      start: 0,
    }));
    getCampaignsList();
    if (selectedChannels.length === 0) setSelectedCampaignsList([]);
  }, [selectedChannels]);

  useEffect(() => {
    const selectedCampaignIds = campaignsList
      .filter((e) => selectedCampaignsList.includes(e.nombre))
      .map((e) => e.idCampana);
    setSearchData((prev) => ({
      ...prev,
      campana: selectedCampaignIds,
      start: 0,
    }));
  }, [campaignsList, selectedCampaignsList]);

  useEffect(() => {
    getCRMHistory();
  }, [searchData]);

  return (
    <div
      className="thin-rounded-border"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 15,
      }}
    >
      <div className="opt-table-content grid-10" id="crm-history">
        <div className="cell cell-start-content">Canal</div>
        <div className="cell">
          <InputIconSearchPanelMultiSelection
            size={0}
            tabIndex={5}
            type={"type-alphanum-ext"}
            options={crmChannels}
            selectedOptions={selectedChannels}
            onChange={(e) => {
              setSelectedChannels(e);
            }}
          ></InputIconSearchPanelMultiSelection>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Fecha desde</div>
        <div className="cell">
          <input
            type="date"
            max="9999-12-31"
            tabIndex={2}
            className="input-field input-cell"
            value={searchData.fechaDesde}
            onChange={(e) => {
              const value = e.target.value;
              setSearchData((prev) => ({
                ...prev,
                fechaDesde: value ? moment(value).format("YYYY-MM-DD") : "",
                start: 0,
              }));
            }}
            onKeyUp={(e) => inputOnEnter(e)}
          ></input>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Cod. Paciente</div>
        <div className="cell crm-history-paciente-cell">
          <InputSearch
            id="crm-history-cod-paciente"
            size={0}
            tabIndex={1}
            link={true}
            code={true}
            op={filterCodPaciente}
            onSelect={onSelectPatient}
            onClickLink={onLinkPatient}
            showCode={true}
            onChange={onChangePatient}
          />
        </div>
        <div className="cell"></div>
        <div className="cell">
          <button className="cell-label" onClick={resetFilters} tabIndex={-1}>
            Limpiar filtros
          </button>
        </div>
        <div className="cell cell-start-content">Campaña</div>
        <div className="cell">
          <InputIconSearchPanelMultiSelection
            size={0}
            tabIndex={5}
            type={"type-alphanum-ext"}
            options={campaignsList.map((e) => e.nombre)}
            selectedOptions={selectedCampaignsList}
            onChange={(e) => {
              setSelectedCampaignsList(e);
            }}
          ></InputIconSearchPanelMultiSelection>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Fecha hasta</div>
        <div className="cell">
          <input
            type="date"
            max="9999-12-31"
            tabIndex={3}
            className="input-field input-cell"
            value={searchData.fechaHasta}
            onChange={(e) => {
              const value = e.target.value;
              setSearchData((prev) => ({
                ...prev,
                fechaHasta: value ? moment(value).format("YYYY-MM-DD") : "",
                start: 0,
              }));
            }}
            onKeyUp={(e) => inputOnEnter(e)}
          ></input>
        </div>
        <div className="cell combined-cells-5"></div>
      </div>
      <div
        className="cell combined-cells-4"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {selectedChannels.length > 0 && (
          <span style={{ fontWeight: "500", fontSize: 13 }}>
            Canales seleccionados: {selectedChannels.length}
          </span>
        )}
        <div className="tag-content">
          {selectedChannels.map((e, i) => {
            return (
              <Tag
                text={e}
                key={i}
                tagId={i}
                onClick={(e) => {
                  setSelectedChannels((prev) =>
                    prev.filter((channel) => channel !== e),
                  );
                }}
              ></Tag>
            );
          })}
        </div>
      </div>
      <div
        className="cell combined-cells-4"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {selectedCampaignsList.length > 0 && (
          <span style={{ fontWeight: "500", fontSize: 13 }}>
            Campañas seleccionadas: {selectedCampaignsList.length}
          </span>
        )}
        <div className="tag-content">
          {selectedCampaignsList.map((e, i) => {
            return (
              <Tag
                text={e}
                key={i}
                tagId={i}
                onClick={(e) => {
                  setSelectedCampaignsList((prev) =>
                    prev.filter((camp) => camp !== e),
                  );
                }}
              ></Tag>
            );
          })}
        </div>
      </div>
      {historyList.length > 0 && (
        <div
          className="opt-table-title"
          style={{
            marginBottom: 0,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            Listado de pacientes ({formatValueUnit(historyList.length)} de{" "}
            <span style={{ color: "#41b3ff" }}>
              {formatValueUnit(data.total)}
            </span>
            )
          </div>
          <DropdownFilter
            optionList={[
              { id: "00", text: "25", active: searchData.total === 25 },
              { id: "01", text: "50", active: searchData.total === 50 },
              { id: "02", text: "100", active: searchData.total === 100 },
            ]}
            op={"Mostrando " + searchData.total}
            selectedOptions={[]}
            onChange={(e) => {
              setSearchData((prev) => ({
                ...prev,
                start: 0,
                total: parseInt(e.text),
              }));
            }}
          ></DropdownFilter>
        </div>
      )}
      <DataTable
        columns={CRMHistoryColumns}
        data={historyList}
        className="custom-datatable"
        noDataComponent="No hay datos disponibles."
      />
      {historyList.length < data.total && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ButtonIconH
            text="Ver más"
            small={true}
            onClick={async () =>
              setSearchData((prev) => ({
                ...prev,
                start: prev.start + prev.total,
              }))
            }
          ></ButtonIconH>
        </div>
      )}
    </div>
  );
}
